<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.plantaFabril.titulo")',
        :voltarPara='{ route: "ConfiguracaoPlanta" }'
    )
    .bloco-cadastro-planta
        h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosCadastrais') }}
        .form-cadastro-planta
            .form-cadastro-planta__row(v-if='isEdicao')
                label.form-cadastro-planta__row-label {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.id') }}
                input.form-cadastro-planta__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.plantaFabril.idPlaceholder")',
                    v-model='planta.externalId',
                    maxlength='15',
                    disabled
                )
            .form-cadastro-planta__row
                label.form-cadastro-planta__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.nome') }}
                input.form-cadastro-planta__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.plantaFabril.nomePlaceHolder")',
                    v-model='planta.nome'
                )
    .bloco-cadastro-planta
        h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosVinculadosPlanta') }}
        .form-cadastro-planta
            .form-cadastro-planta__row
                label.form-cadastro-planta__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.commodity') }}
                el-select(
                    v-model='planta.materialOrigemId',
                    filterable,
                    value-key='id',
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.plantaFabril.selecione")'
                )
                    el-option(
                        v-for='(material, index) in materialOrigem',
                        :key='`material-${material.codigo}`',
                        :label='material.nome',
                        :value='material.id'
                    ) {{ material.nome }}
            .form-cadastro-planta__row
                label.form-cadastro-planta__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.subproduto') }}
                el-select(
                    v-model='planta.subprodutoId',
                    filterable,
                    value-key='id',
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.plantaFabril.selecione")'
                )
                    el-option(
                        v-for='(material, index) in subprodutos',
                        :key='`material-${material.codigo}`',
                        :label='material.nome',
                        :value='material.id'
                    ) {{ material.nome }}
            .form-cadastro-planta__percentual
                    label.form-cadastro-planta__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.percentual') }}
                    .form-cadastro-planta__percentual-input
                        input.form-cadastro-planta__row-input(
                            placeholder='0%',
                            v-mask-bind="['#%', '##%', '###%',]"
                            v-model='planta.percentual'
                            :class="{ 'input-error': erroPercentual }"
                        )
                        .form-cadastro-planta__percentual-btn(
                            @click='adicionarSubproduto',
                            :class="{ 'disabled': !podeAdicionarSubproduto }"
                        )
                            i.mdi.mdi-plus
                            span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.adicionar') }}
                    span.form-cadastro-planta__erro(v-if='erroPercentual') {{ mensagemErroPercentual }}
            .form-cadastro-planta__divider
            .form-cadastro-planta__arrow-divider
                i.mdi.mdi-arrow-left
    .bloco-cadastro-planta
        .form-cadastro-planta
            .form-cadastro-planta__dados-adicionais
                .form-cadastro-planta__dados-adicionais-titulo
                    h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosAdicionais') }}
                .form-cadastro-planta__dados-adicionais-content
                    .form-cadastro-planta__dados-adicionais-vazio(v-if='subprodutosAdicionados.length === 0')
                        span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.dadosAdicionaisVazio') }}
                        h3 {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.adicioneDados') }}
                    template(v-else)
                        .form-cadastro-planta__coluna(
                            v-for='(sub, index) in subprodutosAdicionados',
                            :key='`subproduto-${index}`'
                        )
                            .form-cadastro-planta__linha
                                span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.commodity') }}
                                span {{ getCommodityNome() }}
                            .form-cadastro-planta__linha
                                span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.subproduto') }}
                                span {{ sub.nome || '--' }}
                            .form-cadastro-planta__linha
                                span {{ $t('mensagens.configuracaoRastreabilidade.plantaFabril.percentual') }}
                                span {{ sub.percentual }}%
                            .form-cadastro-planta__linha.form-cadastro-planta__linha--acoes
                                span
                                .form-cadastro-planta__subproduto-remover(@click='removerSubproduto(index)')
                                    i.mdi.mdi-close-circle-outline

        .footer
            .footer__btn.voltar(@click='goToListagemPlantas')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(
                @click='handlerSubmit',
                :class='{ "disabled": !isValid }'
            )
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import mask from '@/utils/directives/mask.js';
import {
    buscarMaterialPorTipo,
    buscarPlantaFabrilPorId,
    cadastrarPlantaFabril,
    atualizarPlantaFabril
} from '@/views/contratos-originacao/planta-fabril/services';

export default {
    name: 'FormularioPlantaFabril',
    components: {
        BaseHeader
    },
    directives: {
        maskBind: mask
    },
    data() {
        return {
            isEdicao: false,
            plantaId: null,
            materialOrigem: [],
            subprodutos: [],
            planta: {
                externalId: '',
                nome: '',
                materialOrigemId: null,
                subprodutoId: null,
                percentual: ''
            },
            subprodutosAdicionados: []
        };
    },
    computed: {
        tituloFormulario() {
            return this.isEdicao
                ? this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.editar')
                : this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.titulo');
        },
        isValid() {
            const nomePreenchido = this.planta.nome && this.planta.nome.trim() !== '';
            const commoditySelecionada = !!this.planta.materialOrigemId;
            const temSubprodutos = this.subprodutosAdicionados.length > 0;
            const somaValida = this.somaPercentuaisSubprodutos <= 100;
            return nomePreenchido && commoditySelecionada && temSubprodutos && somaValida;
        },
        percentualNumerico() {
            if (!this.planta.percentual) return 0;
            return parseFloat(this.planta.percentual.replace('%', '')) || 0;
        },
        somaPercentuaisSubprodutos() {
            return this.subprodutosAdicionados.reduce((acc, sub) => acc + (sub.percentual || 0), 0);
        },
        erroPercentualMaiorQue100() {
            return this.percentualNumerico > 100;
        },
        erroSomaExcede100() {
            if (!this.planta.percentual) return false;
            return (this.somaPercentuaisSubprodutos + this.percentualNumerico) > 100;
        },
        erroPercentual() {
            return this.erroPercentualMaiorQue100 || this.erroSomaExcede100;
        },
        mensagemErroPercentual() {
            if (this.erroPercentualMaiorQue100) {
                return this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroPercentualMaximo');
            }
            if (this.erroSomaExcede100) {
                return this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroSomaPercentual', { soma: this.somaPercentuaisSubprodutos });
            }
            return '';
        },
        podeAdicionarSubproduto() {
            return this.planta.subprodutoId &&
                   this.planta.percentual &&
                   this.percentualNumerico >= 1 &&
                   this.percentualNumerico <= 100 &&
                   !this.erroSomaExcede100;
        }
    },
    mounted() {
        this.verificarModoEdicao();
        this.obterListaMateriais();
        this.buscarSubproduto();
    },
    methods: {
        async buscarSubproduto() {
            const { data } = await buscarMaterialPorTipo(2);
            this.subprodutos = data;
        },
        verificarModoEdicao() {
            const id = this.$route.params.id;
            if (id) {
                this.isEdicao = true;
                this.plantaId = id;
                this.carregarDadosPlanta(id);
            }
        },
        async carregarDadosPlanta(id) {
            try {
                const { data } = await buscarPlantaFabrilPorId(id);
                this.planta.externalId = data.id?.toString() || '';
                this.planta.nome = data.nome || '';
                this.planta.materialOrigemId = data.materialEntrada?.idMaterial || null;

                if (data.subprodutos && data.subprodutos.length > 0) {
                    this.subprodutosAdicionados = data.subprodutos.map(sub => ({
                        idMaterialSaida: sub.idMaterial,
                        nome: sub.nome,
                        codigo: sub.codigo,
                        percentual: sub.percentual
                    }));
                }
            } catch (error) {
                this.$notify.error(
                    this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroBuscar')
                );
            }
        },
        async obterListaMateriais() {
            try {
                const response = await buscarMaterialPorTipo();
                this.materialOrigem = response?.data;
            } catch {
                this.$notify.error(
                    this.$t('mensagens.configuracaoRastreabilidade.materiais.erroObterTipos')
                );
            }
        },
        adicionarSubproduto() {
            if (!this.podeAdicionarSubproduto) {
                if (this.erroPercentual) {
                    this.$notify.warning(this.mensagemErroPercentual);
                } else {
                    this.$notify.warning(
                        this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.preenchaSubproduto')
                    );
                }
                return;
            }

            const subprodutoSelecionado = this.subprodutos.find(
                s => s.id === this.planta.subprodutoId
            );

            if (!subprodutoSelecionado) return;

            const percentualNumerico = parseFloat(
                this.planta.percentual.replace('%', '')
            );

            this.subprodutosAdicionados.push({
                idMaterialSaida: subprodutoSelecionado.id,
                nome: subprodutoSelecionado.nome,
                codigo: subprodutoSelecionado.codigo,
                percentual: percentualNumerico
            });

            this.planta.subprodutoId = null;
            this.planta.percentual = '';
        },
        removerSubproduto(index) {
            this.subprodutosAdicionados.splice(index, 1);
        },
        obterSubprodutoNome(id) {
            const subproduto = this.subprodutos.find(s => s.id === id);
            return subproduto?.nome || '--';
        },
        getCommodityNome() {
            const material = this.materialOrigem.find(
                m => m.id === this.planta.materialOrigemId
            );
            return material?.nome || '--';
        },
        goToListagemPlantas() {
            this.$router.push({ name: 'ConfiguracaoPlanta' });
        },
        montarPayload() {
            return {
                nome: this.planta.nome,
                idMaterialEntrada: this.planta.materialOrigemId,
                subprodutos: this.subprodutosAdicionados.map(sub => ({
                    idMaterialSaida: sub.idMaterialSaida,
                    percentual: sub.percentual
                }))
            };
        },
        async handlerSubmit() {
            if (!this.isValid) return;

            const payload = this.montarPayload();

            try {
                if (this.isEdicao) {
                    await atualizarPlantaFabril(this.plantaId, payload);
                    this.$notify.success(
                        this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.atualizadoSucesso')
                    );
                } else {
                    await cadastrarPlantaFabril(payload);
                    this.$notify.success(
                        this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.cadastradoSucesso')
                    );
                }
                this.goToListagemPlantas();
            } catch (error) {
                this.$notify.error(
                    this.$t('mensagens.configuracaoRastreabilidade.plantaFabril.erroSalvar')
                );
            }
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-planta {
    margin: 20px;
}

.form-cadastro-planta {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();

    &__percentual {
        display: flex;
        gap: 3px;
        flex-direction: column;
    }
    &__percentual-input {
        display: flex;
        gap: 16px;
        input {
            width: 70px;
        }
    }

    &__percentual-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        justify-content: center;
        width: fit-content;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #81BE99;
        color: #81BE99;
        outline: 0;
        padding: 0 15px;
        cursor: pointer;

        &.disabled {
            border-color: #ccc;
            color: #ccc;
            cursor: not-allowed;
            pointer-events: none;
        }
    }

    &__erro {
        color: #E53935;
        font-size: 12px;
        margin-top: 4px;
    }

    &__divider {
        border: 8px solid #E1E1E1;
        border-radius: 8px;
        height: 1px;
    }
    &__arrow-divider {
        position: relative;
        
        i {
            color: #E1E1E1;
            top: -58px;
            left: calc(50% - 30px);
            width: 60px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 60px;
            font-size: 42px;
            line-height: 42px;
            position: absolute;
            transform: rotate(270deg);
        }
    }

    &__dados-adicionais {
        border: 2px dashed #7C7C7C;
        border-radius: $default-border-radius;
        position: relative;
        margin-top: 8px;
    }
    &__dados-adicionais-titulo {
        border: 1px solid #7C7C7C;
        padding: 4px 8px;
        color: #7C7C7C;
        position: absolute;
        border-radius: 20px;
        width: 280px;
        background-color: #F2F2F2;
        position: absolute;
        top: -16px;
        left: calc(50% - 140px);
        h3 {
            text-align: center;
            font-weight: bold;
        }
    }
    &__dados-adicionais-content {
        padding: 8px;
        margin: 38px 16px 16px;
        border-top: 1px solid #555555;
        border-bottom: 1px solid #555555;
    }
    &__dados-adicionais-vazio {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        padding: 32px 0;
    }

    &__coluna {
        display: grid;
        grid-template-columns: repeat(3, 1fr) 60px;
    }

    &__coluna + &__coluna {
        border-top: 1px solid #555555;
    }

    &__linha {
        padding: 0 12px;
        margin: 6px 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        font-size: 16px;

        & :first-child {
            color: #868686;
            font-size: 14px;
        }

        &--acoes {
            align-items: flex-start;
            justify-content: flex-end;
            i {
                font-size: 26px !important;
                color: #d80000 !important;
            }

        }
    }

    &__linha + &__linha {
        border-left: 1px solid #555555;
    }

    &__subproduto-remover {
        cursor: pointer;
        color: #E53935;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s;

        &:hover {
            background-color: #FFEBEE;
        }

        i {
            font-size: 20px;
        }
    }
}

.form-cadastro-planta__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
    position: relative;
}

.form-cadastro-planta__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-planta__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;

    &.input-error {
        border-color: #E53935;
    }
}

.el-select {
    width: 50%;
}

.form-cadastro-planta__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-planta__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-planta__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-planta__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.salvar.disabled {
    background-color: #ccc;
    cursor: not-allowed;
    pointer-events: none;
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
